import React  from 'react';


const Facebook = () => {
  return (
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_31_3317)">
<g clipPath="url(#clip1_31_3317)">
<g clipPath="url(#clip2_31_3317)">
<path d="M20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 14.9913 3.65683 19.1283 8.4375 19.8785V12.8907H5.89843V10H8.4375V7.79687C8.4375 5.29062 9.9305 3.90625 12.2147 3.90625C13.3084 3.90625 14.4532 4.10157 14.4532 4.10157V6.5625H13.1922C11.95 6.5625 11.5625 7.3334 11.5625 8.125V10H14.3359L13.8926 12.8907H11.5625V19.8785C16.3432 19.1283 20 14.9913 20 10Z" fill="#1877F2"/>
<path d="M13.8926 12.8907L14.3359 10H11.5625V8.125C11.5625 7.33418 11.95 6.5625 13.1922 6.5625H14.4532V4.10157C14.4532 4.10157 13.3088 3.90625 12.2147 3.90625C9.9305 3.90625 8.4375 5.29062 8.4375 7.79687V10H5.89844V12.8907H8.4375V19.8785C9.47284 20.0405 10.5272 20.0405 11.5625 19.8785V12.8907H13.8926Z" fill="white"/>
</g>
</g>
</g>
<defs>
<clipPath id="clip0_31_3317">
<rect width="20" height="20" fill="white"/>
</clipPath>
<clipPath id="clip1_31_3317">
<rect width="20" height="20" fill="white"/>
</clipPath>
<clipPath id="clip2_31_3317">
<rect width="20" height="20" fill="white"/>
</clipPath>
</defs>
</svg>

  );
};



export default Facebook;
